function formatIndianInteger(value) {
  const n = Math.round(Number(value));
  if (!Number.isFinite(n)) return '0';
  if (n === 0) return '0';
  const s = String(Math.abs(n));
  if (s.length <= 3) return s;
  const lastThree = s.slice(-3);
  const head = s.slice(0, -3);
  const headFormatted = head.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
  return `${headFormatted},${lastThree}`;
}

function parseIndianInteger(value) {
  const n = Math.round(Number(String(value).replace(/,/g, '')));
  return Number.isFinite(n) ? n : NaN;
}

const registerFacets = () => {
  Alpine.data('xFiltersAndSortby', (sectionId) => ({
    t: '',
    show: false,
    showFilterAside: true,
    loading: false,
    isDesktop: false,
    listLayout: false,
    cachedResults: [],
    searchParamsPrev: window.location.search.slice(1),
    searchParamsInitial: window.location.search.slice(1),
    init() {
      if (localStorage.getItem("list-layout") == 'list') {
        this.listLayout = true;
      }
      this._initLayout();
      this._setListeners();
    },
    _initLayout() {
      let formAside = document.getElementsByClassName('form-aside')[0];
      let formDrawer = document.getElementsByClassName('form-drawer')[0];
      if (window.innerWidth > 767) {
        this.isDesktop = true;
        if (formAside) {
          formAside.setAttribute('id','FacetFiltersForm');
          if (formDrawer) formDrawer.removeAttribute('id');
        } else {
          if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
        }
      } else {
        this.isDesktop = false;
        if (formAside) formAside.removeAttribute('id');
        if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
      }
    },
    _setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev) return;
        this._renderPage(searchParams, false);
      }
      window.addEventListener('popstate', onHistoryChange);

      installMediaQueryWatcher('(min-width: 768px)', this._initLayout);
    },
    toggleLayout(theBoolean) {
      this.listLayout = theBoolean;
      localStorage.setItem("list-layout", theBoolean ? "list" : "grid" );
      window.dispatchEvent(new Event('resize'));
    },
    removeFilter(url) {
      this._reloadFilter(url);
    },
    renderPagination() {
      var formData = {
        'attributes': {
          'collection-pagination': this.$el.value             
        }
      }; 
      fetch(Shopify.routes.root+'cart/update', {
        method:'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(formData)
      }).then(() => {
        this.cachedResults = [];
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
      }); 
    },
    onSubmit(wait = 500) {
      clearTimeout(this.t);

      const func = () => {
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
        if(this.isDesktop) document.getElementById('FormSelectFilter')?.blur();
      }
      
      this.t = setTimeout(() => {
        func();
      }, wait);
    },
    rangePrice(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      priceInput = el.querySelectorAll(".price-input"),
      priceDisplay = el.querySelectorAll(".price-input-display"),
      pricePreview = el.querySelectorAll(".price-preview"),
      range = el.querySelector(".slider .progress");
      const priceGap = 1;
      const sliderMin = Number(rangeInput[0].min);
      const sliderMax = Number(rangeInput[1].max);
      const sliderSpan = sliderMax - sliderMin || 1;

      const syncRange = (minVal, maxVal) => {
        rangeInput[0].value = minVal;
        rangeInput[1].value = maxVal;
        priceInput[0].value = minVal;
        priceInput[1].value = maxVal;
        if (priceDisplay[0]) priceDisplay[0].value = formatIndianInteger(minVal);
        if (priceDisplay[1]) priceDisplay[1].value = formatIndianInteger(maxVal);
        range.style.setProperty('--left_range', ((minVal - sliderMin) / sliderSpan) * 100 + '%');
        range.style.setProperty('--right_range', 100 - ((maxVal - sliderMin) / sliderSpan) * 100 + '%');
        if (pricePreview[0]) pricePreview[0].textContent = formatIndianInteger(minVal);
        if (pricePreview[1]) pricePreview[1].textContent = formatIndianInteger(maxVal);
      };

      rangeInput.forEach((input) => {
        input.addEventListener("input", (e) => {
          e.preventDefault();
          let minVal = Math.round(Number(rangeInput[0].value));
          let maxVal = Math.round(Number(rangeInput[1].value));

          if (maxVal - minVal < priceGap) {
            if (e.target.classList.contains("range-min")) {
              minVal = maxVal - priceGap;
            } else {
              maxVal = minVal + priceGap;
            }
          }

          syncRange(minVal, maxVal);
        });
      });

      const onPriceFieldChange = (input) => {
        const readMin = () => parseIndianInteger(priceDisplay[0]?.value ?? priceInput[0].value);
        const readMax = () => parseIndianInteger(priceDisplay[1]?.value ?? priceInput[1].value);
        let minVal = readMin();
        let maxVal = readMax();
        if (!Number.isFinite(minVal)) minVal = sliderMin;
        if (!Number.isFinite(maxVal)) maxVal = sliderMax;
        minVal = Math.max(sliderMin, Math.min(minVal, sliderMax));
        maxVal = Math.max(sliderMin, Math.min(maxVal, sliderMax));
        if (maxVal - minVal < priceGap) {
          if (input === (priceDisplay[0] || priceInput[0])) {
            minVal = maxVal - priceGap;
          } else {
            maxVal = minVal + priceGap;
          }
        }
        syncRange(minVal, maxVal);
      };

      priceDisplay.forEach((input) => {
        input.addEventListener("change", () => onPriceFieldChange(input));
      });

      priceInput.forEach((input) => {
        input.addEventListener("change", () => onPriceFieldChange(input));
      });
    },
    initRange(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      priceInput = el.querySelectorAll(".price-input"),
      priceDisplay = el.querySelectorAll(".price-input-display"),
      pricePreview = el.querySelectorAll(".price-preview"),
      range = el.querySelector(".slider .progress");

      const minVal = Math.round(Number(rangeInput[0].value));
      const maxVal = Math.round(Number(rangeInput[1].value));
      const sliderMin = Number(rangeInput[0].min);
      const sliderMax = Number(rangeInput[1].max);
      const sliderSpan = sliderMax - sliderMin || 1;

      range.style.setProperty('--left_range', ((minVal - sliderMin) / sliderSpan) * 100 + '%');
      range.style.setProperty('--right_range', 100 - ((maxVal - sliderMin) / sliderSpan) * 100 + '%');
      if (priceDisplay[0]) priceDisplay[0].value = formatIndianInteger(minVal);
      if (priceDisplay[1]) priceDisplay[1].value = formatIndianInteger(maxVal);
      if (pricePreview[0]) pricePreview[0].textContent = formatIndianInteger(minVal);
      if (pricePreview[1]) pricePreview[1].textContent = formatIndianInteger(maxVal);
    },
    _reloadFilter(url) {
      const searchParams = url.indexOf('?') == -1 ? '' : url.slice(url.indexOf('?') + 1);
      this._renderPage(searchParams);
    },
    _createSearchParams(form) {
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    },
    _updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    },
    _renderPage(searchParams, updateURLHash = true) {
      this.searchParamsPrev = searchParams;
      this.loading = true;
      
      if (this.cachedResults[searchParams]) {
        this._renderResults(this.cachedResults[searchParams]);
        return;
      }

      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          this.cachedResults[searchParams] = html;
          this._renderResults(html);
        });

      if (updateURLHash) this._updateURLHash(searchParams);
    },
    _renderResults(html) {
      this._renderFilters(html);
      this._renderProductGridContainer(html);
      this._renderProductCount(html);
      this.loading = false;
    },
    _renderFilters(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      let blockFiltesDrawer = '.form-drawer';
      let blockFiltesAside = '.form-aside';
      const selectBlockFiltesDrawer = document.querySelector(blockFiltesDrawer);
      const selectBlockFiltesAside = document.querySelector(blockFiltesAside);
      let activeTag = document.getElementById("active-filter-tag")

      if (activeTag) {
        activeTag.innerHTML = parsedHTML.getElementById("active-filter-tag").innerHTML;   
      }
      if (selectBlockFiltesDrawer) {
        if (this.$el.id) {  
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        selectBlockFiltesDrawer.innerHTML = parsedHTML.querySelector(blockFiltesDrawer).innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      if (selectBlockFiltesAside) {
        if (this.$el.id) {
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        selectBlockFiltesAside.innerHTML = parsedHTML.querySelector(blockFiltesAside).innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      this._renderAdvancedFilters(parsedHTML);
    },
    _renderAdvancedFilters(html) {
      const destination = document.querySelectorAll(".filter-advanced");
      const source = html.querySelectorAll('.filter-advanced');

      if (source.length > 0 && destination.length > 0) {
        destination.forEach((destination, index) => {
          destination.innerHTML = source[index].innerHTML;
        })
      }
    },
    _renderProductGridContainer(html) {
      document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    },
    _renderProductCount(html) {
      const productCountEl = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
      if (productCountEl) {
        const count = productCountEl.innerHTML;
        const container = document.getElementById('ProductCount_header');
        const containerDrawer = document.getElementById('ProductCountDrawer');
        if (container) container.innerHTML = count;
        if (containerDrawer) containerDrawer.innerHTML = count;
        container.classList.remove('loading');
      }
    },
    _renderAdditionalElements(html) {
      const container = document.getElementById('ProductPerPage');
      if (container) container.innerHTML = html.getElementById('ProductPerPage').innerHTML;
    },
    _filterFocus() {
      Alpine.store('xFocusElement').trapFocus('ProductFilter','CloseFilter');
    },
    _filterRemoveFocus() {
      const activeElement = document.getElementById('btn-filter');
      Alpine.store('xFocusElement').removeTrapFocus(activeElement);
    },
    setFilterHeaderHeight() {
      document.documentElement.style.setProperty('--height-sticky-filter',document.getElementById("FacetsWrapperDesktop").offsetHeight + "px");
    },
    setPositionOptionFilter(el) {
      elRect = el.getBoundingClientRect();
      const elPopup = el.getElementsByClassName('popup-above')[0];
      let spacingRight = window.xViewport.innerWidth - elRect.left;
      let checkSpacing = spacingRight - el.innerWidth;
      if (checkSpacing >= 0) {
        elPopup.style.left = '0px';
      } else {
        elPopup.style.left = checkSpacing+ 'px';
      }
    },
    getPopupPosition(el) {
      this.$nextTick(() => {
        const elPopup = el.getElementsByClassName('popup-above')[0];
        if (elPopup) {
          const popupRect = elPopup.getBoundingClientRect();
          if( popupRect.right > window.xViewport.innerWidth){
            elPopup.style.right = 0;
          }
        }
      });
    }
  }));
};

if (window.__onAlpineInit) {
  window.__onAlpineInit(registerFacets);
} else if (window.Alpine) {
  registerFacets();
} else {
  document.addEventListener('alpine:init', registerFacets);
}